import fetcher from "./http";

export default {
    create(app_code, data) {
        return new Promise((resolve, reject) => {
            fetcher(
                `/${app_code}/direct-links`,
                {
                    method: "POST",
                    body: JSON.stringify(data),
                }
            )
                .then(response => response.ok ? response.json() : response.json().then(err=>reject(err)))
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    },
};
